var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("page-header", {
        staticClass: "mt-4 mt-md-0 mt-sm-4 billing-management__page-header",
        attrs: { page: _vm.pageHeaderConfig }
      }),
      _c("filter-manager", {
        ref: "filter",
        staticClass: "billing-management__filter-manager",
        attrs: {
          "display-advanced": false,
          filters: _vm.filterManagerConfig.basic
        },
        on: {
          academicYear: _vm.onChangeAcademicYear,
          active: _vm.onChangeActive,
          adjustment: _vm.onChangeAdjustment,
          search: _vm.onSearchHandler
        },
        model: {
          value: _vm.filter,
          callback: function($$v) {
            _vm.filter = $$v
          },
          expression: "filter"
        }
      }),
      _c("custom-separator", {
        staticClass: "pt-3 my-4",
        attrs: { text: "Resultado de Ajustes" }
      }),
      _c("callout-list", {
        attrs: { data: _vm.results },
        on: { "on-proposal-status-change": _vm.search }
      }),
      _vm.results.length === 0
        ? _c("custom-result-not-found", {
            attrs: { text: "No hay información disponible" }
          })
        : _vm._e(),
      _vm.results.length > 0 && _vm.pagination.totalItemCount > _vm.pageSize
        ? _c("pagination", {
            attrs: {
              data: _vm.pagination,
              "page-size": _vm.pageSize,
              "show-text": true
            },
            on: { "pagination-go-page": _vm.goToPageHandler }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }